import { addExternalScript } from '../../../../businesscloud/js/includes/utils';
import { cf7RecaptchaScript } from './cf7recaptcha';

/* ------------------------------------------------------------ */
/* -- CF7 + Recaptcha Init -- */
/* ------------------------------------------------------------ */
const cf7Init = () => {
  addExternalScript({ src: 'https://www.google.com/recaptcha/api.js?render=6LcJUKghAAAAADN6g3dlEkCTkLFI7L2KPKvTRhFs&#038;ver=3.0', async: true }).then(() => cf7RecaptchaScript()).catch(err =>
    console.error(err),
  );
};

export default cf7Init;
